// src/components/ViewForms.tsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const ViewForms: React.FC = () => {
  const [forms, setForms] = useState<any[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchForms();
  }, []);

  const fetchForms = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Forms`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setForms(response.data);
    } catch (error) {
      console.error('Failed to fetch forms:', error);
      setError('Failed to load forms. Please try again.');
    }
  };

  const deleteForm = async (id: number) => {
    if (!window.confirm('Are you sure you want to delete this form? This action cannot be undone.')) return;
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/Forms/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setForms(forms.filter(form => form.id !== id));
      alert('Form deleted successfully!');
    } catch (error: any) {
      console.error('Failed to delete form:', error);
      if (error.response && error.response.status === 404) {
        setError('Form not found or you do not have permission to delete it.');
      } else {
        setError('Failed to delete form. Please try again.');
      }
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="mb-4 text-center">View Forms</h2>
      <div className="card shadow-sm">
        <div className="card-header bg-primary text-white">
          <h4 className="mb-0">Your Forms ({forms.length})</h4>
        </div>
        <div className="card-body">
          {error && <div className="alert alert-danger">{error}</div>}
          {forms.length === 0 ? (
            <p className="text-muted text-center">No forms found.</p>
          ) : (
            <ul className="list-group list-group-flush">
              {forms.map(form => (
                <li key={form.id} className="list-group-item d-flex justify-content-between align-items-center">
                  <div>
                    {form.name || `Form ID: ${form.id}`}
                    <br />
                    <small>
                      Client: {form.clientName || 'N/A'} | 
                      Status: {form.status} | 
                      Last Updated: {new Date(form.lastUpdated).toLocaleString()}
                      {form.dueDate && ` | Due: ${new Date(form.dueDate).toLocaleDateString()}`}
                    </small>
                  </div>
                  <div>
                    <Link to={`/form/${form.clientLinkGuid}`} className="btn btn-outline-primary btn-sm me-2" target="_blank">
                      Client Link
                    </Link>
                    <Link to={`/form-details/${form.id}`} className="btn btn-outline-primary btn-sm me-2">
                      View Details
                    </Link>
                    <button
                      onClick={() => deleteForm(form.id)}
                      className="btn btn-danger btn-sm"
                    >
                      Delete
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewForms;